import { Typography } from '@mui/material'
import * as S from './ManageSwapOrReturn.styles'
import FormSearchSwapsOrReturns from '../../components/FormSearchSwapsOrReturns'
import TableListSwapsOrReturns from '../../components/TableListSwapsOrReturns'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { actions } from '../../SwapOrReturnState'
import { useState, useEffect } from 'react'

export const ManageSwapOrReturn = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation<{ fromQueue?: boolean; fromInternal?: boolean }>()

  const swapOrReturnToResolveIds = useSelector((state) => state.swapOrReturn.swapOrReturnToResolveIds)

  const [preventDoubleClick, setPreventDoubleClick] = useState(false)

  useEffect(() => {
    if (!location.state?.fromQueue && !location.state?.fromInternal) {
      dispatch(actions.clearState())
    }
  }, [dispatch, location.state])
  const goToResolveSwapOrReturnPage = () => {
    if (swapOrReturnToResolveIds.length === 0 || preventDoubleClick) return

    setPreventDoubleClick(true)

    const onSuccess = () => {
      setPreventDoubleClick(false)
      history.push('/swap-or-return/resolve')
    }

    dispatch(actions.validateRequestsToResolve({
      idsRequests: swapOrReturnToResolveIds,
      onSuccess,
      onError: () => setPreventDoubleClick(false),
    }))
  }

  const goToCreateSwapOrReturnPage = () => {
    history.push('/swap-or-return/create')
  }

  return (
    <S.Wrapper>
      <Typography variant='h5' fontWeight='bold'>Gestão de Trocas e Devoluções</Typography>
      <FormSearchSwapsOrReturns />
      <TableListSwapsOrReturns />
      <S.BoxFooter>
        <S.CustomButton
          title={swapOrReturnToResolveIds.length === 0 ? 'Resolver Pendências' : `Resolver Pendências (${swapOrReturnToResolveIds.length})`}
          type='button'
          onClick={goToResolveSwapOrReturnPage}
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          data-testid='go-to-resolve-swap-or-return-page-button-test-id'
          disabled={swapOrReturnToResolveIds.length === 0 || preventDoubleClick}
        />
        <S.CustomButton
          title='Criar Pendência'
          type='button'
          onClick={goToCreateSwapOrReturnPage}
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          data-testid='go-to-create-swap-or-return-page-button-test-id'
        />
      </S.BoxFooter>
    </S.Wrapper>
  )
}
